module.exports = __webpack_public_path__ + "img/infografika.c0655f74.jpg";